import { ChakraBox as Box } from "@airhelp/react-ui-components";
import ApraInfo from "../ApraInfo";
import Copyright from "../Copyright";
import SocialIcons from "../SocialIcons";
import CustomGrid from "./CustomGrid";
import Menu from "../Menu";
import type { MenusProps } from "../Footer.d";

const FooterDesktop = ({ menus }: { menus: MenusProps }) => (
  <CustomGrid pt={16} data-testid="footer-section">
    <Box>
      <ApraInfo />
      <Menu menu={menus.imprint} />
      <SocialIcons />
    </Box>
    <Menu label="menu_know_your_rights" menu={menus.knowYourRights} />
    <Box>
      <Menu label="menu_our_products" menu={menus.products} />
      <Box mt={5}>
        <Menu label="menu_support" menu={menus.support} />
      </Box>
    </Box>
    <Menu label="menu_our_company" menu={menus.company} />
    <Menu label="menu_other" menu={menus.legal} />
    <Box gridColumn="span 5" mt={-12} pt={10} pb={8} borderTop="1px" borderColor="#e3e8f0">
      <Copyright />
    </Box>
  </CustomGrid>
);

export default FooterDesktop;
